import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { PainPoints } from './components/PainPoints';
import { Solution } from './components/Solution';
import { Orientations } from './components/Orientations';
import { ContentDetails } from './components/ContentDetails';
import { Features } from './components/Features';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { PurchaseNotification } from './components/PurchaseNotification';
export function App() {
  return <div className="min-h-screen bg-primary text-text-main font-sans selection:bg-accent-cyan/30" data-id="element-0">
      <Navbar data-id="element-1" />
      <Hero data-id="element-2" />
      <Stats data-id="element-3" />
      <PainPoints data-id="element-4" />
      <Solution data-id="element-5" />
      <Orientations data-id="element-6" />
      <ContentDetails data-id="element-7" />
      <Features data-id="element-8" />
      <Pricing data-id="element-9" />
      <Guarantee data-id="element-10" />
      <FAQ data-id="element-11" />
      <Footer data-id="element-12" />
      <PurchaseNotification data-id="element-13" />
    </div>;
}